// enums/statusMetaMap.js
import { BookingStatusEnum } from './bookingStatusEnum'
import { RoomStatusEnum } from './roomStatusEnum'

export const StatusMetaMap = {
  // Booking Status
  [BookingStatusEnum.PENDING]: {
    label: '待確認',
    color: '#EF6E70',
    textColor: '#ffffff',
  },
  //TODO: 2026/1/27 目前狀態未使用到先保留
  [BookingStatusEnum.CONFIRMED]: {
    label: '已確認',
    color: '#F7E6B5',
    textColor: '#6C6B6B',
  },
  [BookingStatusEnum.PAID]: {
    label: '待報到',
    color: '#F7D9BB',
    textColor: '#6C6B6B',
  },
  [BookingStatusEnum.UNPAID]: {
    label: '未付款',
    color: '#D4D9DB',
    textColor: '#6C6B6B',
  },
  [BookingStatusEnum.CHECK_IN]: {
    label: '已報到',
    color: '#81E2C5',
    textColor: '#6C6B6B',
  },
  [BookingStatusEnum.NO_SHOW]: {
    label: '未報到',
    color: '#F7BCBD',
    textColor: '#6C6B6B',
  },
  [BookingStatusEnum.CANCEL]: {
    label: '已取消',
    color: '#f44747',
    textColor: '#FFFFFF',
  },
  [BookingStatusEnum.CHECK_OUT]: {
    label: '已退房',
    color: '#129BC4',
    textColor: '#FFFFFF',
  },

  // Room Status
  [RoomStatusEnum.OPEN]: {
    label: '開放中',
    color: '#FFFFFF',
    textColor: '#6C6B6B',
  },
  [RoomStatusEnum.CLOSE]: {
    label: '不開放',
    color: '#F2F2F2',
    textColor: '#6C6B6B80',
  },
  [RoomStatusEnum.RESERVE]: {
    label: '保留中',
    color: '#6C6B6B',
    textColor: '#ffffff',
  },
  [RoomStatusEnum.BOOKING]: {
    label: '已預約',
    color: '#D9D9D9',
    textColor: '#6C6B6B',
  },
}

function normalizeHotelOrdersList(orders) {
  if (!orders) return []
  if (Array.isArray(orders)) return orders
  if (typeof orders === 'object') return Object.values(orders)
  return []
}

function pickHotelBookingStatus(source) {
  if (!source || typeof source !== 'object') return ''
  return source.status || source.bookingStatus || source.orderStatus || ''
}

function isHotelBookingStatusValue(value) {
  if (value == null || value === '') return false
  const key = String(value).toUpperCase()
  return key in StatusMetaMap && !Object.values(RoomStatusEnum).includes(key)
}

export function resolveHotelOrderStatusMeta(statusRaw) {
  if (statusRaw == null || statusRaw === '') return null
  const key = String(statusRaw).toUpperCase()
  return StatusMetaMap[key] || { label: statusRaw, color: '#D4D9DB', textColor: '#6C6B6B' }
}

export function resolveHotelOrderStatusFromRow(row) {
  if (!row) return ''

  const direct = pickHotelBookingStatus(row)
  if (isHotelBookingStatusValue(direct)) return direct

  const orders = normalizeHotelOrdersList(row.orders)
  for (const order of orders) {
    const status = pickHotelBookingStatus(order)
    if (isHotelBookingStatusValue(status)) return status
  }

  return ''
}
